<template>
  <div class="content">
    <div :class="{bg: true, empty: list.length === 0}">
      <div class="list">
        <div class="titles">
          <span class="theme">采访任务</span>
          <span class="publisher">记者</span>
          <span class="locate">延期设备</span>
          <span class="status">到期时间</span>
          <span class="time">延期至时间</span>
          <span class="upload">理由</span>
          <span class="handles">操作</span>
        </div>
        <empty :mTop="30" :msg="`暂无${$_syscfg.interview}数据`" v-if="list && list.length === 0" />
        <div class="items" v-for="(i, d) in list" :key="d">
          <div class="item">
            <span class="theme" @click="handleGo(i)">
              <p class="words" :title="i.title">
                {{i.title}}
              </p>
            </span>
            <span @click="showCard(i.user_id, $event)" class="publisher">{{i.user_name}}</span>
            <span class="locate">
              <span v-for="(item,index) in i.logs" :key="index" :title="item.title">{{item.title}}</span>
            </span>
            <span class="status">
              <span v-for="(item,index) in i.logs" :key="index">{{item.start}}</span>
            </span>
            <span class="time">
              <!-- <span>{{i.start}}</span> -->
              <span v-for="(item,index) in i.logs" :key="index">{{item.end}}</span>
            </span>
            <span class="upload">
              <span v-for="(item,index) in i.logs" :key="index" :title="item.remark">{{item.remark}}</span>
            </span>
            <span class="handles">
              <span class="btn green" @click="handle(i.id, 0)">通过</span>
              <span class="btn" @click="handle(i.id, 1)">
                退回
              </span>
            </span>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
    </div>
  </div>
</template>

<script>
import pages from '@components/pages'
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'
import dc from '@common/dc'

export default {
  name: 'allInterviews',
  components: {
    pages, empty
  },
  data() {
    return {
      page: {
        page_count: 0,
        pageSize: 10,
        pageIndex: 1,
        total: 0
      },
      list: [],
      searchOptions: {},
      filterOptions: {}
    }
  },
  methods: {
    showCard(id, e) {
      if (id == 0) return

      const el = e.target

      this.$card(id, el)
    },
    handle(id, status) {
      let remark = ''
      if(status == 1){
        this.$Dialog({
          title: '退回理由',
          placeholder: '请输入理由',
          errTitle: '理由不能为空',
          canEdit: true,
          singleBtn: true,
          maxLength: 20
        }).then(res => {
          if(res) {
            remark = res
            let info = {
              id: id,
              status: status,
              remark: remark
            }

            common.myFetch(apis.Delay_pass, info)
            .then((r) => {
              if (r) {
                this.$toast(r)
                this.page.pageIndex = 1;
                this.getList()
              }
            })
          }
        })
      }else{
        let info = {
          id: id,
          status: status,
          remark: remark
        }

        common.myFetch(apis.Delay_pass, info)
        .then((r) => {
          if (r) {
            this.$toast(r)
            this.page.pageIndex = 1;
            this.getList()
          }
        })
      }

      
    },
    setBack() {
      this.$Dialog({
        title: '退回理由',
        canEdit: true,
        maxLength: 20,
        singleBtn: true
      })
    },
    goClue(i) {
      // 去创建线索页
      // const d = {
      //   id: i.id,
      //   title: i.title
      // }
      //
      // this.$router.push({
      //   name: 'creatClue',
      //   params: {
      //     interview: d
      //   }
      // })
      dc.setItv(i)

      common.jump('/creatClue', true)

      setTimeout(() => {
        dc.delItv()
      }, 0)
    },
    goCancel(i) {
      // 撤销操作
      const info = {
        iview_id: i.id
      }

      common.myFetch(apis.Itv_cancel, info)
      .then(r => {
        if (r) {
          this.$toast(r)
          this.getList()
        }
      })
    },
    getList(keyWord) {
      const info = {
        page_type: 'interview',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions)

      common.myFetch(apis.Delay_verify, info)
      .then((data) => {
        this.list = data.list
        this.generateSearchs(data.params.top_search.option.list)
        this.$set(this.page, 'page_count', common.calculatePage(data.pages.row_count - 0, this.page.pageSize))
        this.$set(this.page, 'total', data.pages.row_count - 0)
      })
    },
    generateSearchs(data) {
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }
      this.postSearch(filterData)
    },
    getSearch(d) {
      this.searchOptions = d
      this.page.pageIndex = 1
      this.getList()
    },
    postSearch(data) {
      this.$emit('filterData', data)
    },
    handleGo(i) {
      const hasEdit = !!i.has_edit
      if (hasEdit) {
        this.goEdit(i.iview_id)
      } else {
        this.goDetail(i.iview_id)
      }
    },
    goDetail(i) {
      // this.$router.push({
      //   path: '/interviewDetail',
      //   query: {
      //     r: i
      //   }
      // })

      common.jump(`/interviewDetail?r=${i}`, true)
    },
    async goEdit(i) {
      const newWindow = window.open()
      common.checkPageStatus(i, 0).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin}/editInterview?r=${i}`
        } else {
          newWindow.close()
        }
      })
    },
    async goDelete(i) {
      const c = await this.$confirm('确认删除吗？')
      if (!c) return

      const info = {
        iview_id: i
      }

      common.myFetch(apis.Itv_interview_del, info, 'post')
      .then((data) => {
        if (data) {
          this.$toast(data)
          this.getList()
        }
      })
    }
  },
  mounted() {
    const params = this.$route.params
    Object.assign(this.filterOptions, params)

    this.getList('noKeyWord')
    // 默认使用当天数据
    // this.$refs.interviewFilter.initDate()

  }
}
</script>

<style lang="less" scoped src="@assets/css/interview/delayCheck.less"></style>
